import { makeStyles, css } from '@conexasaude/conexa-hero'

const useStyles = makeStyles({
  container: ({ spacing }) => css`
    margin: ${spacing.xs} 0;
    padding: ${spacing.xxs} 0 ${spacing.xxs};
  `,

  payment: ({ spacing }) => css`
    display: flex;
    gap: ${spacing.xs};
  `,

  inputWrapper: ({ spacing }) => css`
    margin: ${spacing.xs} 0;
  `,
})

export default useStyles
